// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"6b5abd9d","310":"8e3172cc","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};